import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

class NowPlaying extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			item: {}
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'shows'
			}
		}).then( response => {
			const item = response.data.items.filter( item => item.isHero )

			if(item.length){
				this.setState({item: item[0]})
			}
		})
	}

	render() {
		return (
			<section className="container banner">
				{ this.state.item.title ?
					<h2>Opening Next! {decodeURIComponent(this.state.item.title)}</h2>
					: null
				}

				{ this.state.item.banner ?
					<Link to="/now_playing">
						<img src={decodeURIComponent(this.state.item.banner)} alt={decodeURIComponent(this.state.item.title)} />
					</Link>
					: null
				}
			</section>
		)
	}
}

export default NowPlaying



// WEBPACK FOOTER //
// ./src/components/now_playing.js